module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-9561.b28f3138.jpg";